import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'pages.parcelView.parcelInformationSection.title',
    defaultMessage: 'Information',
    description: 'title of the information section',
  },
  parcelInformationSection: {
    editParcel: {
      title: {
        id: 'pages.parcelView.parcelInformationSection.editParcel.title',
        defaultMessage: 'Edit parcel',
        description: 'Title of the edit parcel drawer in the parcel information section',
      },
    },
    button: {
      edit: {
        label: {
          id: 'pages.parcelView.parcelInformationSection.button.edit.label',
          defaultMessage: 'Edit',
          description: 'Label of the edit button in the parcel information section',
        },
      },
    },
    overview: {
      shippingMethod: {
        id: 'properties.shippingMethod',
        defaultMessage: 'Shipping method',
        description: 'title of the shipping method property in the parcel information section',
      },
      status: {
        id: 'properties.status',
        defaultMessage: 'Status',
        description: 'title of the status property in the parcel information section',
      },
      statuses: {
        isFinished: {
          id: 'properties.isFinished',
          defaultMessage: 'Finished',
          description: 'Label of the is finished status in the parcel information section',
        },
        isInTransit: {
          id: 'properties.isInTransit',
          defaultMessage: 'In transit',
          description: 'Label of the is in transit status in the parcel information section',
        },
      },
      shipment: {
        id: 'pages.parcelView.parcelInformationSection.overview.shipment',
        defaultMessage: 'Shipment',
        description: 'title of the shipment in the parcel information section',
      },
      isOutbound: {
        id: 'pages.parcelView.parcelInformationSection.overview.isOutbound',
        defaultMessage: 'Outbound',
        description: 'title of the is outbound in the parcel information section',
      },
      size: {
        id: 'pages.parcelView.parcelInformationSection.overview.size',
        defaultMessage: 'Size',
        description: 'title of the size in the parcel information section',
      },
      weight: {
        id: 'pages.parcelView.parcelInformationSection.overview.weight',
        defaultMessage: 'Weight',
        description: 'title of the weight in the parcel information section',
      },
      trackingCode: {
        id: 'pages.parcelView.parcelInformationSection.overview.trackingCode',
        defaultMessage: 'Track & trace code',
        description: 'title of the tracking code in the parcel information section',
      },
      trackingUrl: {
        id: 'pages.parcelView.parcelInformationSection.overview.trackingUrl',
        defaultMessage: 'Track & trace URL',
        description: 'title of the tracking url in the parcel information section',
      },
      createdAt: {
        id: 'pages.parcelView.parcelInformationSection.overview.createdAt',
        defaultMessage: 'Created at',
        description: 'title of the created at in the parcel information section',
      },
      finishedAt: {
        id: 'pages.parcelView.parcelInformationSection.overview.finishedAt',
        defaultMessage: 'Finished at',
        description: 'title of the finished at in the parcel information section',
      },
      inTransitAt: {
        id: 'pages.parcelView.parcelInformationSection.overview.inTransitAt',
        defaultMessage: 'In transit at',
        description: 'title of the in transit at in the parcel information section',
      },
      shipAt: {
        id: 'pages.parcelView.parcelInformationSection.overview.shipAt',
        defaultMessage: 'Ship at',
        description: 'title of the ship at in the parcel information section',
      },
      position: {
        id: 'pages.parcelView.parcelInformationSection.overview.position',
        defaultMessage: 'Position',
        description: 'title of the position in the parcel information section',
      },
      yes: {
        id: 'app.yes',
        defaultMessage: 'Yes',
        description: 'Yes',
      },
      no: {
        id: 'app.no',
        defaultMessage: 'No',
        description: 'No',
      },
    },
  },
  feedback: {
    parcelUpdated: {
      id: 'pages.parcelView.feedback.parcelUpdated',
      defaultMessage: 'Parcel is updated',
      description: 'feedback message when the parcel is updated successfully',
    },
    parcelNotUpdated: {
      id: 'pages.parcelView.feedback.parcelNotUpdated',
      defaultMessage: 'Parcel could not be updated',
      description: 'feedback message when the parcel could not be updated',
    },
  },
};

export default defineMessages(translations);
